import React from 'react';
import PropTypes from 'prop-types';
import { Table, Button } from 'reactstrap';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { STYLES_INCENTIVES_TITLES, STYLES_INCENTIVES_ORDER } from 'site-modules/shared/constants/incentives';
import { StylesIncentivesLink } from './styles-incentives-link';

import './styles-incentives.scss';

export function StylesIncentives({ styles = [], mmy, link, onIncentiveClick }) {
  return (
    <section className="styles-incentives medium mb-2" data-tracking-parent="incentive_grid">
      <h2 className="heading-3 mb-0_5">All {mmy} Deals</h2>
      <Table className="size-16 text-info sticky-table-header">
        <colgroup>
          <col width="25%" />
        </colgroup>
        <thead>
          <tr className="fw-bold">
            <th className="border-0 bg-white" />
            {STYLES_INCENTIVES_ORDER.map(incentiveType => (
              <th className="border-0 text-center bg-white" key={`${incentiveType}-header`}>
                {STYLES_INCENTIVES_TITLES[incentiveType]}
              </th>
            ))}
            <th className="border-0 bg-white" />
          </tr>
        </thead>
        <tbody>
          {styles.map(style => (
            <tr key={style.id}>
              <td>{style.name}</td>
              {STYLES_INCENTIVES_ORDER.map(incentiveType => (
                <td key={incentiveType} className="text-center">
                  <StylesIncentivesLink incentiveType={incentiveType} onClick={onIncentiveClick} style={style} />
                </td>
              ))}
              <td className="text-center">
                <Button
                  tag="a"
                  href={link}
                  size="sm"
                  color="outline-primary-b size-16"
                  data-tracking-id="view_search_result"
                  data-tracking-value="see_all_for_sale"
                >
                  See all for sale
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </section>
  );
}

StylesIncentives.propTypes = {
  styles: VehicleEntities.Styles,
  link: PropTypes.string.isRequired,
  mmy: PropTypes.string.isRequired,
  onIncentiveClick: PropTypes.func.isRequired,
};
